// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3wVOu","dragIcon":"SortableItem_dragIcon__2HmMk","disabled":"SortableItem_disabled__25dmW"};